<template>
  <div class="wrapper">
    <h1 style="text-align: center">收入成本汇总表</h1>
    <div class="table-title">
      <p>项目名称：{{ detail.projectName ? detail.projectName : "" }}</p>
      <p>{{ detail.createTime ? detail.createTime : "" }}</p>
      <p>单位：元</p>
    </div>
    <div class="table-wrapper">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="内容" prop="title"></el-table-column>
        <el-table-column label="含税金额">
          <template slot-scope="scope">
            <div>{{ formatMoneyNumber(scope.row.data1) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="不含税金额">
          <template slot-scope="scope">
            <div>{{ formatMoneyNumber(scope.row.data2) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
      </el-table>
      <div class="table-footer">
        <p>分管领导：</p>
        <p>工程管理部负责人：</p>
        <p>项目经理：</p>
        <p style="margin-right: 100px">制表：</p>
      </div>
    </div>
    <div class="page-bottom-control">
      <!-- 2是待审核 -->
      <el-button v-if="approveStatus && approveStatus != 2" type="primary" @click="previewHandler">打印</el-button>
      <el-button type="primary" @click="exportData">导出</el-button>
      <el-button type="info" @click="closePage">关闭</el-button>
    </div>

    <el-dialog
      title="预览"
      :visible="dialogVisible"
      width="80%"
      @close="dialogClosed"
    >
      <div id="earningCostGatherPrint">
        <h1 style="text-align: center">收入成本汇总表</h1>
        <div>
          <p>项目名称：{{ detail.projectName ? detail.projectName : "" }}</p>
          <p>{{ detail.createTime ? detail.createTime : "" }}</p>
          <p style="margin-bottom: 16px">单位：元</p>
        </div>
        <div>
          <table
            style="
              width: 100%;
              border: 1px solid black;
              table-layout: fixed;
              border-collapse: collapse;
            "
          >
            <thead>
              <tr style="text-align: left; border-bottom: 1px solid black">
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">序号</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">内容</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">含税金额</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">不含税金额</div>
                </th>
                <th>
                  <div style="padding: 12px 4px">备注</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in tableData"
                :key="index"
                style="border-bottom: 1px solid black"
              >
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{ index + 1 }}
                  </div>
                </td>

                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{ item.title }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{ formatMoneyNumber(item.data1) }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{ formatMoneyNumber(item.data2) }}
                  </div>
                </td>
                <td style="padding: 12px 4px">
                  <div>
                    {{ item.remark }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 16px;
          "
        >
          <p>分管领导：</p>
          <p>工程管理部负责人：</p>
          <p>项目经理：</p>
          <p style="margin-right: 100px">制表：</p>
        </div>
        <div>
          <h2>审批信息</h2>
          <div>
            <table
              style="
                width: 100%;
                border: 1px solid black;
                table-layout: fixed;
                border-collapse: collapse;
              "
            >
              <thead>
                <tr style="text-align: left; border-bottom: 1px solid black">
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">序号</div>
                  </th>
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">员工名称</div>
                  </th>
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">岗位名称</div>
                  </th>
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">相关意见</div>
                  </th>
                  <th>
                    <div style="padding: 12px 4px">当前状态</div>
                  </th>
                  <th>
                    <div style="padding: 12px 4px">时间</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-if="approveData && approveData.length > 0">
                  <tr
                    v-for="(item, index) in approveData"
                    :key="index"
                    style="border-bottom: 1px solid black"
                  >
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div>
                        {{ index + 1 }}
                      </div>
                    </td>

                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div>
                        {{ item.approveUserName }}
                      </div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div>
                        {{ item.jobName }}
                      </div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div>
                        {{ item.opinion }}
                      </div>
                    </td>
                    <td style="padding: 12px 4px">
                      <div>
                        {{ item.statusName }}
                      </div>
                    </td>
                    <td style="padding: 12px 4px">
                      <div>
                        {{ item.updateTime }}
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr style="border-bottom: 1px solid black">
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div style="margin-top: 16px; text-align: center">
        <el-button type="primary" @click="printHandler">打印</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatMoney } from "./utils";
import { formatEarningCostGatherTableData } from "./EarningHelper";
import printJS from "print-js";
import { queryApproveHistoryApi } from "../../services/financeService";
import Constants from "../../utils/consts";
/**
 * 收入成本管理-查看收入记录-收入成本汇总表
 */
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    id: {
      type: [String, Number],
      default: "",
    },
    approveStatus: {
      type: [String, Number],
      default: ''
    },
    closefn: {
      type: Function
    }
  },
  computed: {
    tableData: function () {
      return formatEarningCostGatherTableData(this.detail);
    },
  },
  data() {
    return {
      previewBtnLoading: false,
      dialogVisible: false,
      approveData: [],
    };
  },
  methods: {
    formatMoneyNumber: formatMoney,
    exportData() {
      //:导出收入成本汇总表
      this.$emit("export-click", 2);
    },
    closePage() {
      if(this.closefn) {
        return this.closefn()
      }
      this.bus.$emit("tabClose", "incomingConstDetail");
      this.bus.$emit("navMenuChange", {
        routeId: "incomeConstList",
      });
    },
    previewHandler() {
      this.previewBtnLoading = true;

      queryApproveHistoryApi({
        approveClass: "EARNING_COST",
        itemId: this.id,
      })
        .then((res) => {
          console.log("----回报", res);
          if (res.code == Constants.Code_OK) {
            this.approveData = res.data || [];
            setTimeout(() => {
              this.dialogVisible = true;
            }, 0);
          } else {
            this.previewBtnLoading = false;
          }
        })
        .catch((error) => {
          console.log("----error", error);
          this.previewBtnLoading = false;
        });
    },
    printHandler() {
      printJS({
        printable: "earningCostGatherPrint",
        type: "html",
        targetStyles: ["*"],
        ignoreElements: ["no-print", "bc", "gb"],
        scanStyles: false,
      });
    },
    dialogClosed() {
      this.previewBtnLoading = false;
      this.dialogVisible = false;
    },
  },
};
</script>

<style>
.wrapper {
  padding: 16px;
  box-sizing: border-box;
}

.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}

.page-bottom-control {
  text-align: center;
  padding: 20px 0;
}
</style>
